import React from 'react';
import { InputField } from '@wk/components-react16/dist/input-field/input-field';
import { useValidatedField } from '../../formHooks';
import { ValidatedFieldAtoms } from '../../formAtoms';

interface NumberInputFieldProps {
  disabled?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fieldAtoms: ValidatedFieldAtoms<any, any>;
  helperText?: string;
  label: string;
  max?: number;
  min?: number;
  placeholder?: string;
  required?: boolean;
  step?: number;
}

export const NumberInputField: React.FC<NumberInputFieldProps> = ({
  disabled = false,
  fieldAtoms,
  helperText,
  label,
  max,
  min,
  placeholder,
  required = false,
  step,
}) => {
  const { error, handleBlur, handleChange, showError, value } =
    useValidatedField(fieldAtoms);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    if (inputValue === '' || inputValue === null) {
      handleChange(null);
    } else {
      const numberValue = Number(inputValue);
      if (!Number.isNaN(numberValue)) {
        handleChange(numberValue);
      }
    }
  };

  return (
    <div>
      <InputField label={label} size="small">
        <input
          disabled={disabled}
          max={max}
          min={min}
          onBlur={handleBlur}
          onChange={handleInputChange}
          placeholder={placeholder}
          required={required}
          step={step}
          type="number"
          value={value !== null ? String(value) : ''}
        />
      </InputField>
      {showError && error && (
        <div
          style={{
            color: 'var(--color-error, #d32f2f)',
            fontSize: '12px',
            marginTop: '4px',
          }}
        >
          {error}
        </div>
      )}
      {!showError && helperText && (
        <div
          style={{
            color: 'var(--color-text-secondary, #666)',
            fontSize: '12px',
            marginTop: '4px',
          }}
        >
          {helperText}
        </div>
      )}
    </div>
  );
};
